import cx from 'classnames'
import PropTypes from 'prop-types'
import { KeyboardArrowDownIcon } from 'icons'

import styles from './CollapseChevron.module.scss'

const CollapseChevron = ({ expanded, className }) => (
  <img
    src={KeyboardArrowDownIcon}
    alt='chevron'
    className={cx(styles.chevron, { [styles.expanded]: expanded }, className)}
  />
)

CollapseChevron.propTypes = {
  expanded: PropTypes.bool.isRequired,
  className: PropTypes.string
}

export default CollapseChevron
